<template>
<div>
	<div v-if="!showEquipmentPicker" class="d-flex align-items-center">

		<field
			style='flex-grow: 1'
			:readonly="noTextField"
			v-model="typeName"
			v-on:change="manualInput">
		</field>
		<div>
			<button type="button" 
				class="btn btn-light" 
				:class="{'btn-attached' : !noTextField}"
				title="Select from equipment list" 
				v-on:click="showEquipmentPicker = !showEquipmentPicker">

				<i class="fa fa-truck"></i>
			</button>
		</div>
	</div> 
	<div v-else class="d-flex align-items-center">
		<equipment-picker v-on:selectEvent="setEquipment"></equipment-picker>
		<div>
			<button type="button" class="btn btn-light" title="Swith to free-form" v-on:click="showEquipmentPicker = !showEquipmentPicker">
				<i class="fa fa-pencil-alt"></i>
			</button>
		</div>
	</div>
</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import EquipmentPicker from "@/components/equipment_picker/EquipmentPicker"

export default {
	name: "EquipmentTypePicker",
	components: {
		Field,
		EquipmentPicker
	},
	props: [
		"value",
		"noTextField"
	],	
	data() {
		return {
			typeId: null,
			typeName: "",
			rate: 0,
			unit: null,
			showEquipmentPicker: true
		}
	},
	watch: {
		value() {
			this.setFromValue()
		}
	},
	methods: {
		manualInput() {
			if (!this.noTextField) {
				this.$emit("input",{
					type_id: 0, 
					type_name: this.typeName,
					rate: 0
				})
			}
		},
		setFromValue() {
			if (this.value && typeof this.value != 'string') {
				this.typeName = this.value.typeName

				if ("type_name" in this.value)
					this.typeName = this.value.type_name

				this.typeId = this.value.type_id

				this.rate = this.value.charge_out_rate
				this.unit = this.value.charge_out_rate_unit

				this.showEquipmentPicker = false
			}
		},
		setEquipment(event) {

			if (event.event == 'typeSelected') {
				this.typeName = event.obj.name

				if ("type_name" in event.obj)
					this.typeName = event.obj.type_name

				this.rate = +event.obj.charge_out_rate
				this.rate = this.rate.toFixed(2)
				this.unit = event.obj.charge_out_rate_unit

				this.typeId = event.obj.id

				this.showEquipmentPicker = false

				let multiRates = {}
				try {
					multiRates = JSON.parse(event.obj.charge_out_rates_json)
				}
				catch (e) {}

				this.$emit("input",{
					type_id: this.typeId, 
					type_name: this.typeName,
					rate: this.rate,
					unit: this.unit,
					multiRates
				})
			}
		}
	},
	created() {
		this.setFromValue()
	}
}
</script>